import React, { ReactElement } from 'react';
import { Field } from 'react-final-form';

const FormHidden = ({ name, ...props }): ReactElement => {
  return <Field type="hidden" name={name} id={name} {...props} component="input" />;
};

export default FormHidden;
